import Image from "next/image";
import Heading from "../atoms/Heading";
import { SectionHeadingType } from "../atoms/SectionHeading";
import CtaButtonGroup, { CtaType } from "../molecules/CtaButtonGroup";

type productStatCardTextType = {
  number: string;
  text: string;
};

export type productStatsCardsType = {
  india_values: productStatCardTextType;
  global_values: productStatCardTextType;
  korean_values: productStatCardTextType;
  description: string;
  backgroundImg: string;
  mwebBackgroundImg?: string;
};
export type productStatisticsPropsType = {
  title: SectionHeadingType;
  ctas: CtaType[];
  statsCards: productStatsCardsType[];
  isIndia?: boolean;
  countryCode: string;
};

const ProductStatistics = ({
  title,
  ctas,
  statsCards,
  isIndia,
  countryCode,
}: productStatisticsPropsType) => {
  return (
    <div className=" bg-grey-1 py-3 md:block md:px-6 lg:px-0 lg:py-20">
      <div className="page-max-width">
        <div className="grid grid-cols-2 gap-3 md:gap-6 lg:grid-cols-3  lg:grid-rows-2">
          <div className="col-span-2 mb-2 max-w-[180px] text-title1 font-semibold md:col-span-1 md:mb-0 md:max-w-none">
            <Heading
              as="h3"
              heading={title}
              key="product-statistics-heading"
              fontStyle={"text-title-20 sm:text-title-32"}
              align="text-left"
            />

            <div className="mt-4 hidden md:flex">
              <CtaButtonGroup ctas={ctas} />
            </div>
          </div>
          {statsCards.map((item, index) => {
            const {
              description,
              backgroundImg,
              india_values,
              global_values,
              korean_values,
            } = item;
            const firstCard = index === 0;

            let text, number;
            if (countryCode == "IN") {
              text = india_values.text;
              number = india_values.number;
            } else if (countryCode == "KR") {
              text = korean_values.text;
              number = korean_values.number;
            } else {
              text = global_values.text;
              number = global_values.number;
            }

            return (
              <div
                key={description}
                className={`relative rounded-3xl bg-white p-6 pt-14 ${
                  firstCard ? "col-span-2 md:col-auto" : ""
                }`}
              >
                <div className="absolute right-0 top-0  h-[40px] w-[40px]  md:h-[80px] md:w-[80px] ">
                  <Image
                    src={backgroundImg}
                    alt="title"
                    fill
                    className="rounded-tr-3xl"
                  ></Image>
                </div>
                {firstCard && item.mwebBackgroundImg && (
                  <div className=" absolute left-0 top-0 h-[40px] w-[40px] md:hidden  md:h-[80px] md:w-[80px]">
                    <Image
                      src={item.mwebBackgroundImg}
                      alt="title"
                      fill
                      className="rounded-tl-3xl"
                    ></Image>
                  </div>
                )}
                <div>
                  <span className="text-[32px] font-semibold text-purple-3 md:text-[56px]">
                    {number}
                  </span>

                  {text && (
                    <span
                      className={`${
                        firstCard ? "text-center md:text-start" : ""
                        } ml-[6px] font-bold text-purple-3 
                        ${isIndia ? "md:text-title-24" : "text-[32px] md:text-[56px]"
                        }`}
                    >
                      {text}
                    </span>
                  )}

                  <p className="text-caption text-grey-4 md:text-body">
                    {description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
        <div className="mt-4 flex w-full gap-2 md:hidden">
          <CtaButtonGroup ctas={ctas} />
        </div>
      </div>
    </div>
  );
};

export default ProductStatistics;
